export { default as Form } from 'projects/components/form/ProjectForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/form/index.js